import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {PredictionClickEvent} from "../models/events/prediction-click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {APP} from "../app/consts";
import {ModuleController} from "../../infrastructure/controllers/module-controller";

export class PredictionClickEventHandler extends AnalyticsEventHandler {
  type: ACTION_TYPES = ACTION_TYPES.predictionClickEvent;
  controller: ModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PredictionClickEvent;
  }

  async action(params) {
    this.controller.action(ACTION_TYPES.postSelection, params);
    params.prediction.selectedVoteNum = params.num;
    params.selection = APP.ANALYTICS.SELECTION_MAPPER[params.selectionsCount][params.num];
    params.screen = APP.ANALYTICS.SOURCES[params.currentLinkModelName];

    return super.action(params);
  }
}
